import { CheckoutCompletedItem } from '../../models/checkout-completed-item/checkout-completed-item.interface';
import { mockCheckoutCompletedQuote } from './checkout-completed-quote.mock';

export const mockCheckoutCompletedItem: CheckoutCompletedItem =
  mockCheckoutCompletedQuote;
